export const localNl = {}
